export default __webpack_public_path__ + "static/media/elephants.a45a45ce.jpg";